import React from 'react'
import { ButtonOutline, FormRow } from '../../../components'
import { FormEmail } from './form-email'
import { viewportBreakpoint, useViewport } from '../../../utils'

const ContentEmail = () => {
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet

  return (
    <div className="w-full">
      <p className="text-lg font-bold mb-5 lg:mb-8">Account Email Address</p>
      <FormRow>
        <p className="font-bold mb-2">juanaprilio@gmail.com</p>
        <div style={{maxWidth: isMobile ? '100%' : '126px'}}>
          <ButtonOutline className="w-full" outlineColor="primary">Change</ButtonOutline>
        </div>
      </FormRow>
      <div style={{maxWidth: '541px'}}>
        <FormEmail />
      </div>
    </div>
  )
}

export { ContentEmail }